import React from 'react'
import { Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import Link from '../../../link'
import { routes } from '../../../../routes'

const useStyles = makeStyles(({ typography, spacing, palette }) => ({
  root: {
    ...typography.body.xs,
    color: palette.common.black,
    padding: spacing(3)
  }
}))

const Page1Footer = props => {
  const classes = useStyles()
  return (
    <Typography className={classes.root} data-test='lpq-welcome-footer'>
      You can always change your answers later in your{' '}
      <Link
        to={routes.profile.path}
        underline='always'
        color='primary'
        data-test='lpq-welcome-footer-profile-link'
      >
        Profile
      </Link>
      &nbsp; and we&apos;ll send you reminders to update them in future
    </Typography>
  )
}

export default Page1Footer
